import ZSData from "./ZSData";
import PlayerDataPage from "../UserComponents/PlayerDataPage";

export default class ZSDataPlayerPage extends PlayerDataPage {
  dataComponent(data: any): JSX.Element {
    return <ZSData player={data}/>;
  }
}
